// All text shown by the Bhorosha shell lives in language files (en.json now;
// bn.json for Bangla later). Adding a language = adding a file + one line here.
import en from './en.json';

type Dict = Record<string, string>;
const languages: Record<string, Dict> = { en };
let current: Dict = en;

export function setLanguage(code: string) { current = languages[code] || en; }

/** t('auth.resetSent', { email }) */
export function t(key: string, vars?: Record<string, string | number>): string {
  let s = current[key] ?? (en as Dict)[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

/** Translate an error whose message may be an i18n key (e.g. 'auth.err.invalid'). */
export function tErr(e: unknown): string {
  const msg = e instanceof Error ? e.message : String(e);
  if (current[msg] ?? (en as Dict)[msg]) return t(msg);
  // Already a friendly sentence from our own server functions ("This link has expired. …").
  if (/^[A-Z][^\n]* [^\n]*[.!?]$/.test(msg) && !/violates|exception|syntax|null value|relation /i.test(msg)) return msg;
  return t('err.generic', { message: msg });
}
